// ui/chat/src/components/FixedValueForm.tsx
import React, { useState, useEffect } from 'react';
import { FixedValue, FixedValueCreate } from '../types/costwand.d';
import { Input } from './ui/input.tsx';
import { Button } from './ui/button.tsx';
import { Label } from '@radix-ui/react-label';
import { Checkbox } from './ui/checkbox.tsx'; // Assuming you have a Checkbox component
import { Spinner } from './ui/spinner.tsx'; // Import Spinner

interface FixedValueFormProps {
  initialData?: FixedValue | null;
  onSubmit: (data: FixedValueCreate) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  // error?: string | null; // Removed error prop
}

const FixedValueForm: React.FC<FixedValueFormProps> = ({
  initialData,
  onSubmit,
  onCancel,
  isSubmitting = false,
  // error, // Removed error from destructuring
}) => {
  const [formData, setFormData] = useState<FixedValueCreate>({
    description: '',
    cost: 0,
    active: 1, // Default to active
    created_by: 'admin_user', // Placeholder, replace with actual user context
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        description: initialData.description,
        cost: initialData.cost,
        active: initialData.active ?? 1, // Use existing or default to 1
        created_by: initialData.created_by || 'admin_user', // Keep existing or default
      });
    } else {
      setFormData({ description: '', cost: 0, active: 1, created_by: 'admin_user' });
    }
  }, [initialData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: type === 'checkbox' ? (checked ? 1 : 0) : value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* {error && <p className="text-destructive text-sm">{error}</p>} */} {/* Removed local error display */}
      <div>
        <Label htmlFor="description" className="block text-sm font-medium text-foreground mb-1">Description</Label>
        <Input
          id="description"
          type="text"
          required
          value={formData.description}
          onChange={handleChange}
        />
      </div>
      <div>
        <Label htmlFor="cost" className="block text-sm font-medium text-foreground mb-1">Cost</Label>
        <Input
          id="cost"
          type="number"
          step="0.01"
          required
          value={formData.cost}
          onChange={handleChange}
        />
      </div>
      <div className="flex items-center space-x-2">
        <Checkbox
          id="active"
          checked={formData.active === 1}
          onCheckedChange={(checked) => setFormData((prev) => ({ ...prev, active: checked ? 1 : 0 }))}
        />
        <Label htmlFor="active" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
          Active
        </Label>
      </div>
      <div className="flex justify-end gap-2">
        <Button type="submit" disabled={isSubmitting}>
          {isSubmitting ? <span className="flex items-center gap-2"><Spinner size="sm" /> Saving...</span> : 'Save'}
        </Button>
        <Button type="button" variant="outline" onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </Button>
      </div>
    </form>
  );
};

export default FixedValueForm;